// extracted by css-extract-rspack-plugin
export default {"toast":"gvf2Wp","content":"exMnsv"};